module.exports = __webpack_public_path__ + "media/images/mobile/solutions/parallexbg-7126c7a1084c18313de21c8a60ed1d30.png";